import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';
import TopBar from '../components/TopBar';
import BottomNav from '../components/BottomNav';

const PaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen-safe pb-nav md:pb-0">
      <TopBar />

      <div className="flex items-center justify-center px-4 py-12 min-h-[80vh]">
        <Card className="max-w-md w-full text-center border-2 border-red-500">
          <CardContent className="p-8">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <XCircle className="text-red-600" size={48} />
            </div>
            
            <h1 className="font-heading text-3xl font-bold mb-2 text-red-600">Payment Failed</h1>
            <p className="text-muted-foreground mb-6 text-lg">
              Your payment could not be processed
            </p>

            <p className="text-sm text-muted-foreground mb-6">
              Please try again or contact support if the problem persists.
            </p>

            <div className="flex gap-3">
              <Button
                variant="outline"
                className="flex-1 rounded-xl"
                onClick={() => navigate('/credits')}
              >
                Try Again
              </Button>
              <Button
                className="flex-1 rounded-xl"
                onClick={() => navigate('/dashboard')}
              >
                Back to Dashboard
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      <BottomNav />
    </div>
  );
};

export default PaymentFailed;
